import { ListDataSource } from 'src/app/_shared/classes/list-datasource';
import {
    FichierCompletModel, GedCriteresFiltrageGedModelInput, GedListeDocumentsGedModel,
    MutationGetListeDocumentsGedModelArgs,
} from 'src/graphql/generated-types';
import gql from 'graphql-tag';
import { map } from 'rxjs/operators';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { Observable } from 'rxjs';


export class DocumentBankListDatasource extends ListDataSource<FichierCompletModel> {
    /**
     * Nombre d'éléments chargés (parent default = 200)
     */
    protected numberOfElementsByPage = 50;

    constructor(private readonly graphqlService: GraphqlService) {
        super();
        this.subscriptionsList.push(this.changePage().subscribe());
    }

    reset() {
        super.reset();
        this.subscriptionsList.push(this.changePage().subscribe());
    }

    setFilters(filters: GedCriteresFiltrageGedModelInput = null) {
        this.filters = filters;
    }

    getList(): Observable<any> {
        return this.getListeDocumentsGEDModel({
            ...this.filters,
            OrderByID: true,
            Skip: this.skip,
            Take: this.numberOfElementsByPage,
        }).pipe(
            map((documents: GedListeDocumentsGedModel) => {
                const list = documents?.ListeDocuments?.FichierCompletModel || [];
                return {list, total: documents?.NbElementTot || 0};
            }),
        );
    }

    getListeDocumentsGEDModel(criteres: GedCriteresFiltrageGedModelInput): Observable<GedListeDocumentsGedModel> {
        return this.graphqlService.mutateOne<'GetListeDocumentsGEDModel', MutationGetListeDocumentsGedModelArgs>({
            mutation: gql`
            mutation getDocumentsList($contexte: ContextInfosInput, $criteres: GEDCriteresFiltrageGEDModelInput) {
                GetListeDocumentsGEDModel(contexte: $contexte, criteres: $criteres) {
                    ... documents
                }
            }
            fragment documents on GEDListeDocumentsGEDModel {
                NbElementTot
                ListeDocuments{
                    FichierCompletModel{
                        AlbumId
                        AlbumName
                        CategCode
                        CategorieLibelle
                        DateCreation
                        DateDebut
                        DateFin
                        EditCategCode
                        EditCategLibelle
                        Extension
                        FileBytes
                        Filename
                        IdFile
                        IdLienFichier
                        IsCommentable
                        IsFichierClient
                        IsLikeable
                        LibelleLien
                        OrigineCode
                        RemarqueLien
                        StatutCode
                        StatutLibelle
                        Tags {
                            string
                        }
                        Taille
                        Token
                        TypeFichierIcone
                        TypeFichierLibelle
                        Url
                    }
                }
            }`,
            variables: {criteres}
        });
    }
}
